import React from "react";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import TitleWithDescription from "../../components/TitleWithDescription/TitleWithDescription";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import Title from "../../components/Title/Title";
import { isMobile } from "../../utils/appUtils";
import { useLanguage } from "../../context/LanguageContext";
import { biggestGemstoneTranslations } from "../../translations/biggestGemstone";

function TheBiggestGemstone(): JSX.Element {
  const { language } = useLanguage();
  const t = biggestGemstoneTranslations[language];

  return (
    <div className="min-h-screen bg-white">
      {/* Background cover at the top */}
      <BackgroundCover
        backgroundHeight={isMobile() ? 400 : undefined}
        imagePosition="center"
        backgroundImage="/images/biggest_gemstone_background.jpg"
        isWatchPage={true}
      >
        <div className="absolute top-1/2 left-[10%] md:left-[100px] -translate-y-1/2 z-10">
          <Title
            firstLine={t.backgroundTitle.firstLine}
            secondLine={t.backgroundTitle.secondLine}
            className=""
            animate={true}
          />
        </div>
      </BackgroundCover>

      {/* Introduction */}
      <div className="w-full px-4 md:px-0 py-8 md:py-16">
        <TitleWithDescription
          title={t.intro.title}
          description={t.intro.description}
          layout="row"
          className="px-4 md:px-8 lg:px-24"
        />
      </div>

      <div className="w-full">
        <div className="w-full bg-gradient-to-b from-[#E1D8D3] via-[#FFFFFF] to-[#E1D8D3] py-8 md:py-12">
          <div className="mx-auto px-4 md:px-24 space-y-8 md:space-y-12">
            {/* 1 */}
            <TimelineSection
              title={t.timeline[0].title}
              description={t.timeline[0].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub2.jpg",
                alt: "Section 1",
              }}
            />

            {/* 2 */}
            <TimelineSection
              title={t.timeline[1].title}
              description={t.timeline[1].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub3.jpg",
                alt: "Section 2",
              }}
            />

            {/* 3 */}
            <TimelineSection
              title={t.timeline[2].title}
              description={t.timeline[2].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub4.jpg",
                alt: "Section 3",
              }}
            />

            {/* 4 */}
            <TimelineSection
              title={t.timeline[3].title}
              description={t.timeline[3].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub5.jpg",
                alt: "Section 4",
              }}
            />

            {/* 5 */}
            <TimelineSection
              title={t.timeline[4].title}
              description={t.timeline[4].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub6.jpg",
                alt: "Section 5",
              }}
            />

            {/* 6 */}
            <TimelineSection
              title={t.timeline[5].title}
              description={t.timeline[5].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub7.jpg",
                alt: "Section 6",
              }}
            />

            {/* 7 */}
            <TimelineSection
              title={t.timeline[6].title}
              description={t.timeline[6].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub8.jpg",
                alt: "Section 7",
              }}
            />

            {/* 8 */}
            <TimelineSection
              title={t.timeline[7].title}
              description={t.timeline[7].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub9.jpg",
                alt: "Section 8",
              }}
            />

            {/* 9 */}
            <TimelineSection
              title={t.timeline[8].title}
              description={t.timeline[8].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub10.jpg",
                alt: "Section 9",
              }}
            />

            {/* 10 */}
            <TimelineSection
              title={t.timeline[9].title}
              description={t.timeline[9].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub11.jpg",
                alt: "Section 10",
              }}
            />

            {/* 11 */}
            <TimelineSection
              title={t.timeline[10].title}
              description={t.timeline[10].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub12.jpg",
                alt: "Section 11",
              }}
            />

            {/* 12 */}
            <TimelineSection
              title={t.timeline[11].title}
              description={t.timeline[11].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub13.jpg",
                alt: "Section 12",
              }}
            />

            {/* 13 */}
            <TimelineSection
              title={t.timeline[12].title}
              description={t.timeline[12].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub14.jpg",
                alt: "Section 13",
              }}
            />

            {/* 14 */}
            <TimelineSection
              title={t.timeline[13].title}
              description={t.timeline[13].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub15.jpg",
                alt: "Section 14",
              }}
            />

            {/* 15 */}
            <TimelineSection
              title={t.timeline[14].title}
              description={t.timeline[14].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub16.jpg",
                alt: "Section 15",
              }}
            />

            {/* 16 */}
            <TimelineSection
              title={t.timeline[15].title}
              description={t.timeline[15].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub17.jpg",
                alt: "Section 16",
              }}
            />

            {/* 17 */}
            <TimelineSection
              title={t.timeline[16].title}
              description={t.timeline[16].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub18.jpg",
                alt: "Section 17",
              }}
            />

            {/* 18 */}
            <TimelineSection
              title={t.timeline[17].title}
              description={t.timeline[17].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub19.jpg",
                alt: "Section 18",
              }}
            />

            {/* 19 */}
            <TimelineSection
              title={t.timeline[18].title}
              description={t.timeline[18].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub20.jpg",
                alt: "Section 19",
              }}
            />

            {/* 20 */}
            <TimelineSection
              title={t.timeline[19].title}
              description={t.timeline[19].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub21.jpg",
                alt: "Section 20",
              }}
            />

            {/* 21 */}
            <TimelineSection
              title={t.timeline[20].title}
              description={t.timeline[20].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub22.jpg",
                alt: "Section 21",
              }}
            />

            {/* 22 */}
            <TimelineSection
              title={t.timeline[21].title}
              description={t.timeline[21].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub23.jpg",
                alt: "Section 22",
              }}
            />

            {/* 23 */}
            <TimelineSection
              title={t.timeline[22].title}
              description={t.timeline[22].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub24.jpg",
                alt: "Section 23",
              }}
            />

            {/* 24 */}
            <TimelineSection
              title={t.timeline[23].title}
              description={t.timeline[23].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub25.jpg",
                alt: "Section 24",
              }}
            />

            {/* 25 */}
            <TimelineSection
              title={t.timeline[24].title}
              description={t.timeline[24].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub26.jpg",
                alt: "Section 25",
              }}
            />

            {/* 26 */}
            <TimelineSection
              title={t.timeline[25].title}
              description={t.timeline[25].description}
              mediaPosition="left"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub27.jpg",
                alt: "Section 26",
              }}
            />

            {/* 27 */}
            <TimelineSection
              title={t.timeline[26].title}
              description={t.timeline[26].description}
              mediaPosition="right"
              media={{
                type: "image",
                src: "/images/secret_rainbow_sub28.jpg",
                alt: "Section 27",
              }}
              showLine={false}
            />

            {/* Video Section */}
            <div className="w-full aspect-video max-w-4xl mx-auto">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/QNkrAsjYT7M?si=EcdBmlnzCyoq3weF"
                title="The Secret Rainbow Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TheBiggestGemstone;
